module.exports = __webpack_public_path__ + "static/media/bg_4.7f7c98f9.jpg";